import { useLazyGetCalculationStatisticsSourceStoresEvaluationRatesCsvFileQuery } from '../../apiCalculationEvaluations';
import React, { useCallback } from 'react';
import { useAppDispatch } from '../../../../../store';
import { addToast } from '@ydistri/utils';
import { downloadBlob } from '../../../../ProjectAdministration/YPickCredentials/yPickCredentialsLib';
import { CalculationStatisticClusterType } from '@ydistri/api-sdk';
import { Button } from '@ydistri/ds';

interface StoreEvaluationsDownloadButtonProps {
  calculationId: number;
  clusterType?: CalculationStatisticClusterType;
}

const StoreEvaluationsDownloadButton: React.FC<StoreEvaluationsDownloadButtonProps> = ({
  calculationId,
  clusterType = CalculationStatisticClusterType.Store,
}) => {
  const [trigger] = useLazyGetCalculationStatisticsSourceStoresEvaluationRatesCsvFileQuery();

  const [downloading, setDownloading] = React.useState(false);
  const dispatch = useAppDispatch();

  const handleDownloadClick = useCallback(() => {
    setDownloading(true);
    dispatch(addToast({ message: 'Preparing file for download, please wait...' }));

    trigger({ calculationId, clusterType })
      .unwrap()
      .then(qrBlob => {
        if (qrBlob) {
          downloadBlob(qrBlob, `Calculation_${calculationId}_StoreEvaluations.zip`);
          dispatch(addToast({ message: 'Download completed' }));
        }
      })
      .catch((error: unknown) => {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Meh, I can't use the Error type in the callback and assertions are also no-go
        const err = error as Error;
        dispatch(
          addToast({
            message: `There was an issue when preparing the file: ${err.message}`,
            isError: true,
          }),
        );
      })
      .finally(() => {
        setDownloading(false);
      });
  }, [calculationId, clusterType, dispatch, trigger]);

  return (
    <Button onClick={handleDownloadClick} disabled={downloading} $colorVariant="ghost">
      Export
    </Button>
  );
};

export default StoreEvaluationsDownloadButton;
